import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {

  heading: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      console.log(data);
      this.heading = data.heading;
    }

    onNoClick(): void {
      this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/confirm-dialog/confirm-dialog.component.ts